<template>
    <div class="page-root">
    <div id="particles-js"></div>
    <div class="container">
        <h1>RosterPal - Personal - 2026</h1><br><br>
        <form @submit.prevent="handleSubmit" class="form">
            <v-row>
                <v-col cols="12" md="4">
                    <label for="date">Select Date:</label>
                    <input type="date" v-model="date" required />
                </v-col>

                <v-col cols="12" md="4">
                    <label for="name">Enter Name:</label>
                    <input type="text" v-model="name" required />
                </v-col>

                <button type="submit" class="submit-button">Show the week</button><br/>
                <button class="button" v-if="result" @click="prevWeek()">← Prev week</button>
                <button class="button" v-if="result" @click="nextWeek()">Next week→</button>
            </v-row>
        </form>
        <center v-if="loader">
            <div class="loader"></div>
        </center>
        <div v-if="result" class="result">
            <h2>Shift Pattern:</h2>
            <v-chip-group class="d-flex flex-column">
                <v-chip v-for="(value, key) in about" :key="key"
                    :style="{ backgroundColor: getChipColor(key), color: 'white' }">
                    {{ value }}
                </v-chip>
            </v-chip-group>

            <table>
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Shift</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in result" :key="item.Date"
                        :style="{ backgroundColor: item.Date.startsWith('S') ? '#B7D7F7' : 'white' }">
                        <td>
                            <div style="display: flex; justify-content: space-between; align-items: center;">
                                <span>{{ item.Date }}</span>
                                <div style="display: flex; gap: 4px;">
                                    <v-chip v-if="item.Date.startsWith('Sun') && item.Shift.startsWith('Night')" key=""
                                        color="#f6b26b" dark>Sunday Night</v-chip>
                                    <v-chip v-if="isHoliday(item.Date)" key=""
                                        color="#9de37f" dark>Holiday at IFS</v-chip>
                                </div>
                            </div>
                        </td>
                        <td>{{ item.Shift }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <modal-component :isVisible="showModal" :options="options" @close="showModal = false"
            @select="handleSelect"></modal-component>
        <v-snackbar v-model="snackbar" timeout=2000 centered col>
            Invalid Data

            <template v-slot:actions>
                <v-btn color="pink" variant="text" @click="snackbar = false">
                    Close
                </v-btn>
            </template>
        </v-snackbar>
    </div>
    </div>
</template>

<script>
import ModalComponent from './ModalComponent.vue';
export default {
    components: {
        ModalComponent
    },
    data() {
        return {
            loader: false,
            date: new Date().toISOString().split("T")[0], // Default to today's date
            name: "",
            result: null,
            showModal: false,
            options: [],
            about: {
                Name: '',
                Capability: '',
                Roster: ''
            },
            snackbar: false,
holidays: [
    '03/Jan/2026',
    '15/Jan/2026',
    '01/Feb/2026',
    '04/Feb/2026',
    '02/Mar/2026',
    '01/Apr/2026',
    '13/Apr/2026',
    '14/Apr/2026',
    '30/Apr/2026',
    '01/May/2026',
    '01/May/2026',
    '02/May/2026',
    '30/May/2026',
    '29/Jun/2026',
    '29/Jul/2026',
    '26/Aug/2026',
    '27/Aug/2026',
    '26/Sep/2026',
    '25/Oct/2026',
    '24/Nov/2026',
    '23/Dec/2026',
    '25/Dec/2026'
]

        };
    },
    methods: {
        initParticles() {
        if (!window.particlesJS) return;

        particlesJS("particles-js", {
            particles: {
                number: {
                    value: 150,
                    density: { enable: true, value_area: 800 }
                },
                color: {
                    value: ["#aa87d7", "#8a5db8", "#6a3399"]
                },
                shape: { type: "circle" },
                opacity: { value: 4 },
                size: { value: 4, random: true },
                move: {
                    enable: true,
                    speed: 2,
                    direction: "none",
                    out_mode: "out"
                }
            },
            interactivity: {
                events: {
                    onhover: { enable: false },
                    onclick: { enable: false }
                }
            },
            retina_detect: true
        });
    },
        async handleSubmit() {
            this.result = null
            this.loader = true
            localStorage.setItem("myNameCookie", this.name); // Save to local storage
            await this.fetchData(); // Await fetchData to ensure it completes before proceeding
        },
        nextWeek() {
            const currentDate = new Date(this.date);
            currentDate.setDate(currentDate.getDate() + 7);
            this.date = currentDate.toISOString().split("T")[0];
        },
        prevWeek() {
            const currentDate = new Date(this.date);
            currentDate.setDate(currentDate.getDate() - 7);
            this.date = currentDate.toISOString().split("T")[0];
        },
        isHoliday(dateString) {
            const datePart = dateString.split(',')[1].trim();
            return this.holidays.includes(datePart);
        },

        async fetchData() {
            const formattedDate = this.date.replace(/-/g, "/");
            const year = formattedDate.split('/')[0];
            if (year != 2026) {
                alert("RosterPal only has data of the year 2026");
                this.loader = false
                return
            }

            const url = `https://rosterpalb.induwara.me/getRoster/${formattedDate}/${this.name}`;
            // const url = `http://127.0.0.1:5000/getRoster/${formattedDate}/${this.name}`;

            try {
                const response = await fetch(url);

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                const data = await response.json();
                // Check if the response is in the expected format
                // console.log(data);

                if (data[0].Capability) {
                    // Extract shift data from the response
                    const aboutData = data.slice(0).flat()[0]; // Assuming this returns the about object
                    const shifts = data.slice(1).flat();
                    // console.log((aboutData.length));

                    this.result = shifts; // Store the fetched data

                    // Update the about object with the fetched values
                    this.about.Capability = aboutData.Capability + " - " + aboutData.Area; // Set Capability
                    this.about.Name = aboutData.Name;             // Set Name
                    this.about.Roster = aboutData.Roster;         // Set Roster
                    this.loader = false
                } else {
                    this.options = this.extractOptions(data); // Extract options based on your logic
                    this.showModal = true; // Show the modal
                    // Handle the case where the response does not match the expected format
                    console.log("Unexpected response format:", response);
                    this.loader = false

                }


            } catch (error) {
                this.snackbar = true
                console.error('Error fetching data:', error);
                this.loader = false

            }
        }, extractOptions(data) {
            // Logic to extract options from the response data
            return data.map(item => item); // Replace 'someProperty' with the relevant property
        },
        handleSelect(option) {
            this.name = option
            this.handleSubmit()
            // console.log("Selected option:", option);
            // Handle the selected option here
        },
getChipColor(key) {
    switch (key) {
        case 'Capability':
            return '#8fce00'; // Vivid Amber (High Contrast)
        case 'Name':
            return '#e06666'; // Deep Purple (Anchor)
        default:
            return '#f1c232'; // Vivid Cyan (Vibrant Contrast)
    }
},

        
    },

    mounted() {
        const savedName = localStorage.getItem("myNameCookie");
        if (savedName) {
            this.name = savedName;
        }
        this.initParticles();
    }
};
</script>

<style scoped>
/* HTML: <div class="loader"></div> */
.loader {
    --s: 25px;
    --g: 65px;

    width: calc(3*(1.353*var(--s) + var(--g)));
    display: grid;
    justify-items: end;
    aspect-ratio: 3;
    overflow: hidden;
    --_m: linear-gradient(90deg, #0000, #000 15px calc(100% - 15px), #0000);
    -webkit-mask: var(--_m);
    mask: var(--_m);
}

.loader:before {
    content: "";
    width: 200%;
    background:
        linear-gradient(90deg, #6a3399 50%, #0000 0),
        conic-gradient(from -90deg at var(--s) calc(0.353*var(--s)),
            #fff 135deg, #cab1f6 0 270deg, #aa87d7 0);
    background-blend-mode: multiply;
    --_m:
        linear-gradient(to bottom right,
            #0000 calc(0.25*var(--s)), #000 0 calc(100% - calc(0.25*var(--s)) - 1.414*var(--g)), #0000 0),
        conic-gradient(from -90deg at right var(--g) bottom var(--g), #000 90deg, #0000 0);
    -webkit-mask: var(--_m);
    mask: var(--_m);
    background-size: calc(100%/3) 100%, calc(100%/6) 100%;
    -webkit-mask-size: calc(100%/6) 100%;
    mask-size: calc(100%/6) 100%;
    -webkit-mask-composite: source-in;
    mask-composite: intersect;
    animation: l10 1s infinite linear;
}

@keyframes l10 {
    to {
        transform: translate(calc(100%/3))
    }
}



body {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    font-family: Arial, sans-serif;
    margin: 0;
    padding: 0;
    background-color: #f8f4ff;
    color: #333;
}

.container {
    flex: 1;
    width: 90%;
    max-width: 1200px;
    margin: 2rem auto;
    padding: 1.5rem;
    background-color: #fff;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
}

h1 {
    text-align: center;
    color: #6a3399;
}

form {
    margin-bottom: 2rem;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 1rem;
}

label {
    margin-right: 0.5rem;
    font-weight: bold;
}

input[type="date"],
input[type="text"],
select,
button {
    padding: 0.75rem;
    font-size: 1rem;
    border: 1px solid #ddd;
    border-radius: 4px;
    width: 100%;
    box-sizing: border-box;
}

.button {
    padding: 0.75rem;
    font-size: 1rem;
    border: 1px solid #ddd;
    border-radius: 50px; /* Makes the edges nicely rounded */
    width: 50%;
    box-sizing: border-box;
    background-color: #7d7d7d;
    color: white; /* Optional: improves contrast */
}


button {
    background-color: #6a3399;
    color: white;
    border: none;
    cursor: pointer;
}

button:hover {
    background-color: #4a236c;
}

.result {
    margin-top: 1.5rem;
    padding: 1.5rem;
    border: 1px solid #ddd;
    background-color: #fafafa;
    border-radius: 8px;
}


.result h2 {
    margin-top: 0;
    color: #6a3399;
}

.result table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 1rem;
}

.result table,
.result th,
.result td {
    border: 1px solid #ddd;
    padding: 0.75rem;
    text-align: left;
}

.result th {
    background-color: #6a3399;
    color: white;
}

.result tr:hover {
    background-color: #e0ccf2; /* Lighter purple for row highlight */
}

.response-text {
    background-color: #f4f4f4;
    padding: 1rem;
    border-radius: 4px;
    white-space: pre-wrap;
    word-wrap: break-word;
}

footer {
    text-align: center;
    padding: 1rem;
    background-color: #333;
    color: white;
}

@media (min-width: 600px) {
    .container {
        width: 80%;
    }

    form {
        justify-content: space-between;
    }
}


.page-root {
    position: relative;
    min-height: 100vh;
}

#particles-js {
    position: fixed;
    inset: 0;
    z-index: -1;
    background-color: #eee;
}

</style>